export default {
  // 사용자
  GET_SHERLOCK_USER_INFO: "/api/v1/sherlock/user", // 셜록 사용자 정보 조회
  POST_SHERLOCK_USER_CREATE: "/api/v1/sherlock/user", // 셜록 사용자 신규 등록

  // 기타
  POST_SHERLOCK_DELINQUENCY_NOTI_REQUEST: "/api/v1/sherlock/delinquency/noti-request", // 셜록 체납∙연체 알림 신청

  // NZSC-3236 영업용 견적받기 리드 (비회원 연락처 + 첨부파일 제출)
  POST_SHERLOCK_LEAD: "/api/v1/sherlock/lead", // 셜록 견적 리드 제출 (multipart/form-data)

  // 상품
  GET_SHERLOCK_PRODUCT_LIST: "/api/v1/sherlock/product", // 셜록 상품 목록 조회

  // 포인트
  GET_SHERLOCK_POINT_STATUS: "/api/v1/sherlock/point/status", // 셜록 포인트 상태 조회
  GET_SHERLOCK_POINT_HISTORY: "/api/v1/sherlock/point/history", // 셜록 포인트 내역 조회
  POST_SHERLOCK_POINT_CONVERT: "/api/v1/sherlock/point/convert", // 셜록 이용권 -> 포인트 전환

  // 무료체험
  POST_START_SHERLOCK_FREE_TRIAL: "/api/v1/sherlock/freetrial/start", // 셜록 무료체험 시작
  POST_SHERLOCK_CHANGE_RECHARGE_AMOUNT: "/api/v1/sherlock/freetrial/recharge-amount", // 셜록 무료체험 자동 충전 금액 변경
  POST_SHERLOCK_AUTO_CHARGE_POINT: "/api/v1/sherlock/freetrial/auto-charge", // 셜록 무료체험 자동 충전 포인트 충전

  // 결제
  GET_SHERLOCK_BILLING_KEY: "/api/v1/sherlock/payment/billing-key", // 셜록 결제 빌링키 조회
  GET_SHERLOCK_PAYPLE_INFO: "/api/v1/sherlock/payment/payple/info", // 셜록 결제 payple 시작정보 조회
  GET_SHERLOCK_PORTONE_INFO: "/api/v1/sherlock/payment/portone/info", // 셜록 결제 portone 시작정보 조회 (카카오페이)
  POST_SHERLOCK_PAYMENT_INIT: "/api/v1/sherlock/payment/init", // 셜록 최초 결제 시작
  POST_SHERLOCK_PAYMENT_BILLING_KEY: "/api/v1/sherlock/payment/billing-key", // 셜록 빌링키로 결제 (Payple)
  POST_SHERLOCK_PORTONE_BILLING_KEY: "/api/v1/sherlock/payment/portone/billing-key", // 셜록 빌링키로 결제 (PortOne/카카오페이)
  POST_SHERLOCK_PORTONE_CARD_REGISTER: "/api/v1/sherlock/payment/portone/card-register", // 셜록 카카오페이 카드 등록
  POST_SHERLOCK_PAYPLE_CARD_REGISTER: "/api/v1/sherlock/payment/payple/card-register", // 셜록 페이플 카드 등록 (FE callback 직통)

  // 카드 관리
  GET_SHERLOCK_CARDS: "/api/v1/sherlock/payment/cards", // 셜록 등록된 카드 목록 조회
  DELETE_SHERLOCK_CARD: "/api/v1/sherlock/payment/cards", // 셜록 카드 삭제 (+ /{cardSeq})
  PATCH_SHERLOCK_DEFAULT_CARD: "/api/v1/sherlock/payment/cards", // 셜록 기본 카드 변경 (+ /{cardSeq}/default)
  POST_SHERLOCK_CHECK_DUPLICATE_OWNER_PROPERTIES:
    "/api/v1/sherlock/deal/check-duplicate/owner-properties", // 셜록 다주택조회 중복 조회 여부 확인
  POST_SHERLOCK_ASK_DEAL_OWNER_PROPERTIES: "/api/v1/sherlock/deal/ask/owner-properties", // 셜록 다주택조회 포인트 사용 가능 여부 조회
  POST_SHERLOCK_ASK_DEAL_ESTATE_DOCUMENT: "/api/v1/sherlock/deal/ask/estate-document", // 셜록 등기부조회 포인트 사용 가능 여부 조회
  POST_SHERLOCK_DEAL_ASK_ADDRESS_SEARCH: "/api/v1/sherlock/deal/ask/address-search", // 셜록 다주택조회 주소지로 조회 포인트 가능 여부 조회

  // 주소조회
  GET_SHERLOCK_ESTATE_IROS_ADDRESS_LIST: "/api/v1/sherlock/estate/iros/address", // 셜록 주소조회 등기부 주소 목록 조회

  //다주택 조회
  GET_SHERLOCK_ESTATE_OWNER_PROPERTY_LIST: "/api/v1/sherlock/estate/owner-property-list", // 셜록 유저가 지금까지 포인트 써서 조회한 다주택 조회 목록
  GET_SHERLOCK_ESTATE_OWNER_PROPERTY_LIST_SEARCH:
    "/api/v1/sherlock/estate/owner-property-list/search", // 셜록 유저가 지금까지 포인트 써서 조회한 다주택 조회 목록 검색
  GET_SHERLOCK_ESTATE_OWNER_PROPERTY_DETAIL: "/api/v1/sherlock/estate/owner-property-detail", // 셜록 다주택 조회 상세
  GET_SHERLOCK_ESTATE_ADDRESS_SEARCH_LIST: "/api/v1/sherlock/estate/address-search-list", // 셜록 현재 유효한 (아직 다주택 조회 신청 안된) 주소지 조회 목록 조회
  GET_SHERLOCK_ESTATE_ADDRESS_SEARCH_RESULT: "/api/v1/sherlock/estate/address-search-result", // 셜록 단일 주소지 조회 결과 조회

  POST_SHERLOCK_DEAL_PROCESS_ESTATE_DOCUMENT: "/api/v1/sherlock/deal/process/estate-document", // 셜록 다주택 조회 후 그 안에서 등기부 조회
  POST_SHERLOCK_PROCESS_OWNER_PROPERTIES: "/api/v1/sherlock/deal/process/owner-properties", // 셜록 다주택조회 포인트 사용 처리
  POST_SHERLOCK_DEAL_PROCESS_ADDRESS_SEARCH: "/api/v1/sherlock/deal/process/address-search", // 셜록 다주택조회 주소지로 조회 포인트 사용 처리
  POST_SHERLOCK_DEAL_PROCESS_OWNER_PROPERTIES_FROM_SEARCH:
    "/api/v1/sherlock/deal/process/owner-properties-from-search", // 셜록 소유자 2명 이상 나온 주소지 다주택 조회

  //등기부 조회
  GET_SHERLOCK_ESTATE_ESTATE_QUERY_LIST: "/api/v1/sherlock/estate/estate-query-list", // 셜록 다주택 경로로 들어간 것 말고 등기부만 단독으로 조회한 내역들 목록
  GET_SHERLOCK_ESTATE_ESTATE_QUERY_LIST_SEARCH: "/api/v1/sherlock/estate/estate-query-list/search", // 셜록 다주택 경로로 들어간 것 말고 등기부만 단독으로 조회한 내역들 목록 검색
  POST_SHERLOCK_DEAL_PROCESS_ESTATE_DOCUMENT_SEPARATE:
    "/api/v1/sherlock/deal/process/estate-document-separate", // 셜록 등기부 단독 조회
  POST_SHERLOCK_PROCESS_ESTATE_DOCUMENT: "/api/v1/sherlock/deal/process/estate-document", // 셜록 등기부조회 포인트 사용 처리

  // NZSC-2833: 추정시세 유저 수동입력 저장
  POST_SHERLOCK_OWNER_PROPERTY_USER_PRICE: "/api/v1/sherlock/estate/owner-property/user-price", // 셜록 다주택 조회 결과 유저 입력 시세 저장

  // NZSC-2859: 자산원클릭 법인명 자동완성 (bizno 프록시, 포인트 차감 없음)
  POST_SHERLOCK_CORP_NAME_SEARCH: "/api/v1/sherlock/corp-name-search", // 법인명 자동완성 검색
  POST_SHERLOCK_CORP_REGNO_LOOKUP: "/api/v1/sherlock/corp-regno-lookup", // 법인등록번호 역조회

  // NZSC-3047/3050: 자산원클릭 구독형 가격제
  GET_SHERLOCK_SUBSCRIPTION: "/api/v1/sherlock/subscription",
  GET_SHERLOCK_SUBSCRIPTION_PLANS: "/api/v1/sherlock/subscription/plans",
  GET_SHERLOCK_SUBSCRIPTION_USAGE_HISTORY: "/api/v1/sherlock/subscription/usage-history",
  POST_SHERLOCK_SUBSCRIPTION_SUBSCRIBE: "/api/v1/sherlock/subscription/subscribe",
  POST_SHERLOCK_SUBSCRIPTION_UPGRADE: "/api/v1/sherlock/subscription/upgrade",
  POST_SHERLOCK_SUBSCRIPTION_DOWNGRADE: "/api/v1/sherlock/subscription/downgrade",
  POST_SHERLOCK_SUBSCRIPTION_DOWNGRADE_CANCEL: "/api/v1/sherlock/subscription/downgrade/cancel",
  POST_SHERLOCK_SUBSCRIPTION_CANCEL: "/api/v1/sherlock/subscription/cancel",
  POST_SHERLOCK_SUBSCRIPTION_REVOKE_CANCEL: "/api/v1/sherlock/subscription/cancel/revoke",
  POST_SHERLOCK_SUBSCRIPTION_CHARGE_EXTRA: "/api/v1/sherlock/subscription/charge-extra",
  POST_SHERLOCK_SUBSCRIPTION_CONVERT_FROM_POINTS:
    "/api/v1/sherlock/subscription/convert-from-points",

  // NZSC-3054 / NZSC-3058: 셜록 체납∙연체 조회 (KCB)
  POST_SHERLOCK_CREDIT_CORPORATE: "/api/v1/sherlock/credit/corporate",
  POST_SHERLOCK_CREDIT_INDIVIDUAL_REQUEST: "/api/v1/sherlock/credit/individual/request",
  POST_SHERLOCK_CREDIT_INDIVIDUAL_CONFIRM: "/api/v1/sherlock/credit/individual/confirm",
  GET_SHERLOCK_CREDIT_HISTORY: "/api/v1/sherlock/credit/history",
  GET_SHERLOCK_CREDIT_CONSENT: "/api/v1/sherlock/credit/consent",

  // NZSC-3074: KCB 본인인증 결합 (셜록 외부 동의 페이지 → 본인인증 → 결과)
  POST_VERIFY_PHONE_PREPARE_GUEST: "/api/v1/user/verification/phone/prepare/guest",
  POST_VERIFY_PHONE_RESULT_GUEST: "/api/v1/user/verification/phone/result/guest",
  GET_SHERLOCK_CREDIT_INDIVIDUAL_RESULT: "/api/v1/sherlock/credit/individual/result",

  // NZSC-3076 / NZSC-3075: 요청자(셜록 회원) 측 이력 row → 결과 페이지 재진입용 endpoint.
  GET_SHERLOCK_CREDIT_BY_SEQ: "/api/v1/sherlock/credit",

  // NZSC-3102 / NZSC-3103: 자산원클릭 B2B 다건 조회
  POST_SHERLOCK_PARSE_OWNER_PROPERTIES_FILE: "/api/v1/sherlock/deal/parse-owner-properties-file", // 엑셀 파싱 (multipart)
  POST_SHERLOCK_ASK_DEAL_OWNER_PROPERTIES_BATCH: "/api/v1/sherlock/deal/ask/owner-properties-batch", // 다건 조회 포인트 사용 가능 여부
  POST_SHERLOCK_PROCESS_OWNER_PROPERTIES_BATCH:
    "/api/v1/sherlock/deal/process/owner-properties-batch", // 다건 조회 처리
};
